import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SystemService} from '../../../services/system.service';
import {Entity} from '../../product/product.model';
import ClientFormComponent from '../../../components/client-form/client-form.component';
import {EntityListComponent} from '../../../components/entity-list/entity-list.component';
import {InstrumentTypeComponent} from '../../../components/instrument-type/instrument-type.component';
import {InstrumentService} from '../../../components/instrument/instrument.service';
import {Subject} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';
import {InstrumentType} from '../../../interfaces/interfaces';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'instrument-type-page',
    templateUrl: './instrument-type-page.component.html'
})
export class InstrumentTypePageComponent implements OnInit, OnDestroy {

    instrumentsType: Entity[];
    instrumentType: any;

    private readonly _unsubscribeAll: Subject<any>;

    @ViewChild('instrumentForm')
    instrumentForm: InstrumentTypeComponent;

    @ViewChild('entityList')
    entityList: EntityListComponent;


    constructor(public _systemService: SystemService, public _instrumentService: InstrumentService, private _snackBar: MatSnackBar) {
        this._unsubscribeAll = new Subject();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    ngOnInit(): void {
        this._instrumentService.allInstrumentType$.pipe(
            takeUntil(this._unsubscribeAll),
            tap((data) => {
                this.instrumentsType = data;
            })
        ).subscribe();
    }

    newInstrumentType(): void {
        if (this.entityList) {
            this.entityList.deselectAll();
        }
        this.selected(new InstrumentType());
        // this._instrumentService.updateInstrumentType(new InstrumentType()).subscribe(
        //     (newType) => {
        //         this.instrumentType = newType;
        //         if (this.entityList) {
        //             this.entityList.deselectAll();
        //         }
        //         this.selected(newType);
        //     },
        //     (error) => {
        //         console.error('Error al crear nuevo tipo de instrumento:', error);
        //     }
        // );
    }

    selected(entity): void{
        this.instrumentType = entity;
        this.instrumentForm.selected(entity);
    }
    entityChanged(saved: InstrumentType): void {
        if (!saved) {
            return;
        }

        if (!this.instrumentsType) {
            this.instrumentsType = [saved];
            return;
        }

        const idx = this.instrumentsType.findIndex(i => i.id === saved.id);
        if (idx > -1) {
            this.instrumentsType[idx] = saved;
        } else {
            this.instrumentsType.push(saved);
        }

        // Opcional: seleccionar el que se acaba de guardar
        this.selected(saved);
    }

    refreshList(): void{
        this._instrumentService.getAllInstrumentType().subscribe(
            () => {
                this._snackBar.open('Lista refrescada correctamente', 'Cerrar', {
                    duration: 3000,
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    panelClass: ['success-snackbar']
                });
            },
            (error) => {
                console.error('Error al refrescar la lista:', error);
                this._snackBar.open('Error al refrescar la lista', 'Cerrar', {
                    duration: 5000,
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    panelClass: ['error-snackbar']
                });
            }
        );
    }


}
